import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { environment } from '../../environments/environment';
import { UserModel } from '../models/index';
import 'rxjs/Rx';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const URL = environment.apiBaseUrl;

@Injectable()
export class AuthenticationService {
  constructor(private http: HttpClient, private router: Router) {}

  private _currentUser: UserModel;
  private _firstTimeLogin: boolean;

  login(username: string, password: string, captcha: string): Observable<boolean> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    const body = `username=${username}&password=${password}&grant_type=password&captchaResponse=${captcha}`;

    return this.http
      .post(`${URL}token`, body, { headers })
      .map((result: any) => {
        if (result) {
          localStorage.setItem('access_token', result.access_token);
          this._currentUser = new UserModel();
          this._currentUser.userName = result.userName;
          this._currentUser.userId = result.userId;
          this._currentUser.role = result.role;
          this._firstTimeLogin = result.firstTimeLogin === 'True';

          localStorage.setItem('user', JSON.stringify(this._currentUser));
          return true;
        }
        // Map returns Observable<type> by default
        return false;
      })
      .catch(() => Observable.of(false));
  }

  logout(): void {
    this._currentUser = null;
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
  }

  get currentUser(): UserModel {
    if (!this._currentUser) {
      const user: UserModel = JSON.parse(localStorage.getItem('user'));
      this._currentUser = user;
      return user;
    }
    return this._currentUser;
  }

  isAdmin(): boolean {
    return this.currentUser.role.toLowerCase() === 'administrators';
  }

  isAdvisor(): boolean {
    return this.currentUser.role.toLowerCase() === 'advisors';
  }

  get isLoggedIn(): boolean {
    const token = localStorage.getItem('access_token');
    const user = localStorage.getItem('user');
    return (token || '').length > 0 && (user || '').length > 0;
  }

  get firstTimeLogin(): boolean {
    return this._firstTimeLogin;
  }

  set firstTimeLogin(firstTimeLogin: boolean) {
    this._firstTimeLogin = firstTimeLogin;
  }

  goToFirstPage() {
    if (this.firstTimeLogin) {
      this.router.navigateByUrl('set-password');
      return;
    }

    if (this.isAdmin()) {
      this.router.navigateByUrl('users');
    } else {
      this.router.navigateByUrl('advisors/payout');
    }
  }
}
